import { ArrowLeft } from "lucide-react"
import { usePage } from "@inertiajs/react"
import { Button } from "@/components/ui/primitives"
import { useTranslation } from "@/hooks/use-translation"
import { shotReturnPlaceKey, type ShotReturnPlace } from "@/lib/shot-return-place"
import { useShotPanelStore } from "@/stores/shot-panel-store"

/** Toolbar stand-in for the shot panel close control. Same slot as page create CTAs. */
export function ShotPanelReturnButton() {
  const { t } = useTranslation("shot")
  const { url } = usePage()
  const requestClose = useShotPanelStore((s) => s.requestClose)
  const closeScene3d = useShotPanelStore((s) => s.scene3dReturnClose)
  const closeRoomViewer = useShotPanelStore((s) => s.roomViewerReturnClose)
  const place = shotReturnPlaceKey(url)
  let label = t("panel.back")
  if (closeRoomViewer || closeScene3d) label = t("panel.backToShot")
  else if (place) label = t("panel.backTo", { place: t(returnPlaceKey(place)) })

  return (
    <Button
      type="button"
      variant="secondary"
      size="sm"
      className="hidden h-7 shrink-0 md:inline-flex md:gap-1.5 md:px-2.5 md:text-[11px]"
      title={label}
      aria-label={label}
      onClick={() => {
        if (closeRoomViewer) closeRoomViewer()
        else if (closeScene3d) closeScene3d()
        else requestClose()
      }}
    >
      <ArrowLeft className="h-3.5 w-3.5" />
      {label}
    </Button>
  )
}

function returnPlaceKey(place: ShotReturnPlace): `panel.returnPlace.${ShotReturnPlace}` {
  return `panel.returnPlace.${place}`
}
